export interface IProfileAuthOutputModel {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  avatar: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  roleName: ERoleNameUser;
}

export interface ILoginInputModel {
  email: string;
  password: string;
}

export interface ILoginOutputModel {
  profile: IProfileAuthOutputModel;
  refreshToken: string;
  accessToken: string;
}

export interface IForgotPasswordInputModel {
  email: string;
}

export interface IForgotPasswordOutputModel {
  message: string;
}

export interface IResetPasswordInputModel {
  email: string;
  token: string;
  newPassword: string;
}

export interface IResetPasswordOutModel {
  _id: string;
  name: string;
  userNumber: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IVerifyRefreshTokenOutputModel {
  profile: IProfileAuthOutputModel;
}

export enum ERoleNameUser {
  "ADMIN" = "ADMIN",
  "USER" = "USER",
}
